import React, { useEffect, useState } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Update = ({ show, onClose, data, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const [newDate, setnewDate] = useState(null);
    const [newDateDisp, setnewDatedisp] = useState(null);


    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!newDate) {
            newErrors.ndate = "This Field is Required.";
        }
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        } else {
            setErrors({});
        }
        
        let postdata = {
            upcomming_maintanence_date: newDate
        }
        
        axios.put(`${baseURL}/manage_maintenance/${data.sno}`, postdata)
            .then(response => {
                refresh();
                onClose();
                toast.success("Maintenance Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Maintenance Updation Failed");
            });
            
    };


    return (
        <Modal className="modal fade" show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Maintenance Schedule</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className='col-lg-12'>
                            <div className='row'>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Category</label>
                                    <label className='text-black fs-6 font-w500'>{data.category_name}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Brand</label>
                                    <label className='text-black fs-6 font-w500'>{data.brand_name}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Number</label>
                                    <label className='text-black fs-6 font-w500'>{data.number}</label>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Registration Date</label>
                                    <div>
                                        <Badge bg="info" className='text-white fs-7 py-0 px-1'>{formatDate(data.reg_date)}</Badge>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                    <label className='text-gray-800 font-w500 fs-7'>Service date</label>
                                    <label className='text-black fs-6 font-w500'>{formatDate(data.upcomming_maintanence_date)}</label>
                                </div>
                            </div>
                            <label className="text-black font-w500 fs-5 mt-3 mb-3">Reschedule</label>
                            <div className="col-lg-12 mb-3">
                                <label className="text-black font-w500 fs-7 ">Reschedule Maintenance Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Reschedule Maintenance Date'
                                        format="DD-MM-YYYY"
                                        value={newDateDisp}
                                        minDate={new Date().setHours(0,0,0)}
                                        onChange={(date) => {
                                            setnewDatedisp(date);
                                            const formattedDate = date.format('YYYY-MM-DD');
                                            setnewDate(formattedDate);
                                        }}
                                    />
                                </div>
                                {errors.ndate && <div className="text-danger fs-8 mt-1">{errors.ndate}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        {/* <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Schedule<i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default Update;
